module.exports = __webpack_public_path__ + "img/cgj.3ed5b997.png";